import { API_ENDPOINTS, API_ERROR_MESSAGES } from '../constants/api';
import { apiFetch } from './apiClient';

async function fetchDashboardReport(endpoint) {
  const response = await apiFetch(endpoint);
  let result;

  try {
    result = await response.json();
  } catch {
    throw new Error(API_ERROR_MESSAGES.liveDashboardReadFailed);
  }

  if (!response.ok || !result.success) {
    throw new Error(result?.message || API_ERROR_MESSAGES.liveDashboardFetchFailed);
  }

  return result.data;
}

export function fetchLiveDashboard() {
  return fetchDashboardReport(API_ENDPOINTS.liveDashboard.summary);
}
